import { useEffect,useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import { setPressure } from "../redux/chartoptions";
import IndividualComponentPopup from "./individualcomponentpopup";



function Pressure(){

    const [showModal,setShowModal] = useState(false);
   

    const myData = useSelector(state => state.api);

    let current_pressure = myData.pressure[0];

        
        
        const dispatch = useDispatch();
        const checked = useSelector(state => state.chartOption.pressure)

        const showPopup = () =>{
            setShowModal(true);
        }
    
        const hidePopup = () =>{
            setShowModal(false);
        }
        

    return(
        <>
            <div className="parameter" id="pressure" onClick={showPopup}>                    
                <div className="label2">
                    <input type="checkbox" id="pressure" checked={checked} onChange={(e) => {dispatch(setPressure(e.target.checked))}} />
                    <label htmlFor="pressure" >Pressure</label>
                </div>
                    
                <div className="parameter_ul">
                    <ul>
                        <li type="none">Current Pressure : {parseFloat(current_pressure).toFixed(2)} <br/> Pascal </li>
                    </ul>
                </div>
            </div>
            {showModal && <IndividualComponentPopup hider={hidePopup} bgcolor={"#91c8e4"} />}
        </>
    );
}

export default Pressure;